<script setup lang="ts">
const props = defineProps<AppBrandProps>();

type AppBrandProps = {
  width?: number | string;
  height?: number | string;
  class?: string;
  variant?: keyof typeof brandVariants;
};

const brandVariants = {
  default: await import("~/assets/images/brand-primary.svg"),
  white: await import("~/assets/images/brand-white.svg"),
};

const brandImport = brandVariants[props.variant || "default"];
const brandString = brandImport.default;
</script>

<template>
  <img :src="brandString" alt="brand" v-bind="props" />
</template>

<style scoped></style>
